import { IActivityAction } from '@models/actions/IBaseAction';
import { createActivityModalExecutor } from '@organisms/actions/createActivityModalExecutor';
import { getActivityIdFromCompositeId } from '@utils/helpers';
import { IChangePerformerProps } from './IChangePerformerProps';
import { ChangePerformerModal } from './ChangePerformerModal';

export const ChangePerformerExecutor = createActivityModalExecutor<IChangePerformerProps>({
    modal: ChangePerformerModal,
    defaultModalSize: 'l',
    mapProps: ({ objId, action, okButtonText, cancelButtonText, modalSize, completeHandler }) => ({
        activityId: getActivityIdFromCompositeId(objId),
        docId: (action as IActivityAction)?.docId ?? '-1',
        actionKey: action.key,
        title: action.options?.title ?? '',
        okButtonText,
        cancelButtonText,
        modalSize,
        reasons: action.options?.reasons ?? [],
        addCustomReason: action.options?.addCustomReason ?? false,
        customReasonRequired: action.options?.customReasonRequired ?? false,
        customReasonMinLength: action.options?.customReasonMinLength ?? 0,
        customReasonLabel: action.options?.customReasonLabel ?? 'Причина замены',
        completeHandler,
    }),
});
